/// <amd-module name="CodeCoverage/CodeCoverageCiTab/Components/CoverageDonutChart" />
import * as Resources from "CodeCoverage/CodeCoverageCiTab/Resources";
import * as React from "react";
import { Chart } from "VSS/Features/Charts/Chart";
import { ChartProps, ChartTypesConstants, Datum, PieChartOptions } from "VSS/Features/Charts/Contracts";
import { VssComponent } from "VSS/Platform/Layout";

export interface IDonutChartProps {
    errorText?: string;
    chartData?: Datum[];
}

export class CoverageDonutChart extends VssComponent<IDonutChartProps> {
    public render(): JSX.Element {
        return (
            <div>
                <Chart {...this.getDonutChartOptions()} />
            </div>
        );
    }

    private getDonutChartOptions(): ChartProps {
        const formattedChartOptions = {
            hostOptions: {
                width: 60,
                height: 60
            },
            legend: { enabled: false },
            title: Resources.CoverageDonutChart,
            chartType: ChartTypesConstants.Pie,
            pageContext: this.context.pageContext,
            suppressMargin: true,
            suppressAnimation: true,
            specializedOptions: {
                size: "60",
                innerSize: "35",
                showLabels: false
            } as PieChartOptions,
            series: [
                {
                    data: this.props.chartData ? this.props.chartData.filter(o => o.y !== 0) : []
                }
            ],
            xAxis: { labelValues: this.props.chartData ? this.props.chartData.map(chartData => chartData.name || "") : [] }
        } as ChartProps;

        return formattedChartOptions;
    }
}
